import { getSentryExtra } from '../error/getSentryExtra';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import Logger from '../lib/Logger';
import { getQueryParam } from '../routing/getQueryParam';
import { Data } from '../signup-data/DATA';
import { OPTIONAL_DOMAIN_QUERY_PARAM } from '../step-company-domain/useCompanyDomain';
import { bulkUpdate } from '../store/signup-data/action-creators';
import { getSignupDataValue } from '../store/signup-data/selectors';
import { Tracker } from '../store/tracking/action-creators';
import { storePredictedTypeaheadValues } from '../store/typeahead/action-creators';
import { arrayContainsAll } from '../utils/data-structure-utils/arrayContainsAll';
import { getDomainFromEmail } from '../utils/getDomainFromEmail';
import { isTestingOrInternalEmailDomain } from '../utils/isTestingOrInternalEmailDomain';
const LOG = Logger.getLogger('handleCompanyInfo');
export const handleCompanyInfoSuccess = ({
  domain,
  name,
  industries = []
}, dispatch, getState) => {
  const industriesArray = industries || [];
  const state = getState();
  dispatch(Tracker.signupInteraction('company-info-prefill-success'));
  const email = getSignupDataValue(state, Data.Email);
  const domainFromEmail = getDomainFromEmail(email);
  const userDomain = getSignupDataValue(state, Data.CompanyDomain);
  const userCompanyName = getSignupDataValue(state, Data.CompanyName);
  const hasOptionalDomainParam = getQueryParam(OPTIONAL_DOMAIN_QUERY_PARAM);
  const shouldPreFillCompanyNameByFlowConfig = getFlowConfig().shouldPreFillCompanyName;
  const shouldPreFillCompanyName = !userCompanyName && Boolean(name) && shouldPreFillCompanyNameByFlowConfig;
  let shouldUpdateDomain = !userDomain && Boolean(domain);

  if (isTestingOrInternalEmailDomain(domainFromEmail)) {
    domain = 'hubspot-test.com';
    shouldUpdateDomain = shouldUpdateDomain && !hasOptionalDomainParam;
  }

  const predicted = industriesArray.length > 0;
  const industryNames = predicted ? industriesArray.map(industry => industry.name) : [];
  dispatch(Tracker.signupInteraction(predicted ? 'industry-prefill-success' : 'industry-prefill-empty-industries', {
    numberOfDisplayed: industriesArray.length
  }));
  const dataToUpdate = Object.assign({}, shouldUpdateDomain && domain && {
    [Data.CompanyDomain]: domain
  }, {}, shouldPreFillCompanyName && name && {
    [Data.CompanyName]: name
  });
  dispatch(bulkUpdate(dataToUpdate));
  dispatch(storePredictedTypeaheadValues(industryNames, Data.Industry));
};
export const handleCompanyInfoError = (error, dispatch, getState) => {
  dispatch(Tracker.signupInteraction(`industry-prefill-${error.status}`));
  dispatch(Tracker.signupInteraction(`company-info-prefill-error-${error.status}`));
  const email = getSignupDataValue(getState(), Data.Email);
  const domainFromEmail = getDomainFromEmail(email); // Here we only log unknown statuses.
  // 404 - Returned when we don't find any company information for the requested domain
  // 503 - Returned when the Biden API is down or unreachable.

  if (!arrayContainsAll({
    array: [404, 503],
    element: error.status
  })) {
    LOG.error('Company Information Request Failed', {
      extra: Object.assign({}, getSentryExtra(error), {
        domainFromEmail
      })
    });
  }
};